import { render, staticRenderFns } from "./NavDrawer.vue?vue&type=template&id=46e04859&scoped=true"
import script from "./NavDrawer.vue?vue&type=script&lang=ts"
export * from "./NavDrawer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e04859",
  null
  
)

export default component.exports